import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import { hasAnalyticsConsent, subscribeToConsent } from "utils/cookieConsent";

const gaId = process.env.REACT_APP_GA4_MEASUREMENT_ID;

let gaInitialized = false;

const usePageAnalytics = () => {
  const location = useLocation();
  const [analyticsAllowed, setAnalyticsAllowed] = useState(hasAnalyticsConsent);

  // Picks up consent granted or withdrawn from the banner without a reload.
  useEffect(
    () =>
      subscribeToConsent((consent) =>
        setAnalyticsAllowed(Boolean(consent && consent.categories.analytics))
      ),
    []
  );

  useEffect(() => {
    // ReactGA.initialize used to run at module load, which set _ga cookies
    // before the visitor had any chance to consent. It is now deferred until
    // consent is actually granted.
    if (!gaId || !analyticsAllowed) return;

    if (!gaInitialized) {
      try {
        ReactGA.initialize(gaId);
        gaInitialized = true;
      } catch {
        // GA4 blocked by an ad blocker or failed to load
        return;
      }
    }

    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      title: document.title,
      search: location.search,
    });
  }, [location?.pathname, location?.search, analyticsAllowed]);
};

export default usePageAnalytics;
